document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll("video[autoplay]");
  videos.forEach((video) => {
    video.play().catch((error) => {
      console.error("Autoplay failed for video:", video, error);
    });
  });

  document.addEventListener("cart:changed", async function (event) {
    const cart = event.detail.cart;

    const rewardVariantEls = document.querySelectorAll(
      "[data-reward-variant-id]"
    );

    rewardVariantEls.forEach((rewardVariantEl) => {
      const rewardVariantId = rewardVariantEl.getAttribute(
        "data-reward-variant-id"
      );
      const rewardAmount = rewardVariantEl.getAttribute("data-reward-amount");
      const rewardQuantity = rewardVariantEl.getAttribute(
        "data-quantity"
      );
      const numItemsInCart = cart.item_count;

      const cartAmountInUSD =
        Currency != undefined
          ? Currency.convert(cart.total_price, cart.currency, "USD")
          : cart.total_price;

      let itemsToAdd = [];
      let itemsToRemove = [];
      const rewardAmountExists = rewardAmount > 0;

      if ((rewardAmountExists && cartAmountInUSD > rewardAmount) || (rewardQuantity && rewardQuantity <= numItemsInCart)) {
        const rewardVariant = cart.items.find(
          (item) => item.variant_id == rewardVariantId
        );
        if (!rewardVariant) {
          itemsToAdd.push(rewardVariantId);
        }
      }

      if ((rewardAmountExists && cartAmountInUSD < rewardAmount) || (rewardQuantity && rewardQuantity >= numItemsInCart)) {
        const rewardVariant = cart.items.find(
          (item) => item.variant_id == rewardVariantId
        );
        if (rewardVariant) {
          itemsToRemove.push(rewardVariantId);
        }
      }

      itemsToAdd.forEach(async (item) => {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: item,
            quantity: 1,
          }),
        }).then(() => {
          refreshCart();
        });
      });
      itemsToRemove.forEach(async (item) => {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: item,
            quantity: 0,
          }),
        }).then(() => {
          refreshCart();
        });
      });
    });
  });
});

function refreshCart() {
  document.dispatchEvent(new CustomEvent("cart:refresh"));
}

class CDUpsellSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.parentContainer = this.parentElement;
    this.previousButton = this.parentContainer.querySelector("[data-previous]");
    this.nextButton = this.parentContainer.querySelector("[data-next]");
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this, {
      slidesPerView: 2.5,
      spaceBetween: 24,
      slidesOffsetBefore: 24,
      slidesOffsetAfter: 24,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.previousButton,
      },
    });
  }
}

customElements.define("cd-upsell-swiper", CDUpsellSwiper);

class CDCheckoutButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.submitButton = this.querySelector("button[type='submit']");
    this.submitButton.addEventListener("click", () => {
      this.submitButton.setAttribute("aria-busy", "true");
    });
  }
}

customElements.define("cd-checkout-button", CDCheckoutButton);